"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HookType = exports.UseType = exports.Type = void 0;
/*
 * @Author: your name
 * @Date: 2021-11-03 13:50:20
 * @LastEditTime: 2022-02-22 13:49:07
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \sdk\bi-sdk\src\types\chart.ts
 */
var Type;
(function (Type) {
    Type["Bar"] = "Bar";
    Type["Line"] = "Line";
    Type["Map"] = "Map";
    Type["Pie"] = "Pie";
    Type["Scatter"] = "Scatter";
    Type["Radar"] = "Radar";
    Type["Gauge"] = "Gauge";
    Type["LiquidFill"] = "LiquidFill";
    Type["HeatMap"] = "HeatMap";
    Type["SanKey"] = "SanKey";
})(Type = exports.Type || (exports.Type = {}));
var UseType;
(function (UseType) {
    UseType["ProgressBar"] = "ProgressBar";
})(UseType = exports.UseType || (exports.UseType = {}));
var HookType;
(function (HookType) {
    HookType["beforeCreate"] = "beforeCreate";
    HookType["created"] = "created";
    HookType["beforeRender"] = "beforeRender";
    HookType["afterRender"] = "afterRender";
    HookType["beforeDestroy"] = "beforeDestroy";
    HookType["destroyed"] = "destroyed";
})(HookType = exports.HookType || (exports.HookType = {}));
//# sourceMappingURL=chart.js.map